'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIDialogHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIDialogHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      use = _ref.use,
      rest = _objectWithoutProperties(_ref, ['children', 'className', 'use']);

  return _react2.default.createElement(
    'header',
    _extends({}, rest, {
      className: (0, _reactUtils.classNames)('private-modal__header', 'uiDialogHeader', className, { 'private-modal__header--with-toolbar': use === 'toolbar' })
    }),
    _react2.default.createElement(
      'div',
      { className: 'private-modal__header__inner' },
      children
    )
  );
}

UIDialogHeader.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  use: _react.PropTypes.oneOf(['default', 'toolbar'])
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/dialog/UIDialogHeader.js
// module id = 326
// module chunks = 0